<template>
<div class="content-wrapper">
<div v-if="$gate.isAdmin()">
  <admin-settings></admin-settings>
</div>
<div v-if="$gate.isUser()">
  <user-settings></user-settings>
</div>
<div v-if="$gate.isProvider()">
  <provider-settings></provider-settings>
</div>
<div v-if="$gate.isGreyManager()">
  <greyman-settings></greyman-settings>
</div>


</div>
</template>

<script>
    export default {
        mounted() {
            console.log('Settings Mounted')
        }
    }
</script>